import {
  SidebarContent,
  SidebarGroup,
  SidebarHeader,
} from "@/client/components/shad/sidebar";

import { createFileRoute } from "@tanstack/react-router";
import { HiraStatus } from "./-features/hiraStatus";
import { ScrollArea } from "@/client/components/shad/scroll-area";
import { HiraCamera } from "./-features/hiraCamera";

export const Route = createFileRoute("/(protected)/map/hira/")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className="">
      <SidebarHeader className=" text-sm border-b px-3 py-3">
        <HiraStatus />
      </SidebarHeader>
      <SidebarContent className="p-1 py-3 text-xs">
        {/*<SidebarGroup>
          <div className="flex items-center space-x-2">TEST</div>
        </SidebarGroup>*/}

        <SidebarGroup className="flex flex-col gap-5">
          <ScrollArea className="grow flex flex-col h-[60vh] -mr-3 pr-3">
            <HiraCamera />
          </ScrollArea>
        </SidebarGroup>
      </SidebarContent>
    </div>
  );
}
